import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from '@elements/dom-utils';
import Chart from 'chart.js/auto';

const selectors = {
    base: '.js-statistics',
    container: '.js-statistics__container',
};
export function init() {
    onFind(selectors.base, function (baseElement) {
        let data = JSON.parse(baseElement.getAttribute('data-statistics'));
        let statistics = data.data;
        let labels = data.labels;
        let type = data.type;
        let formatAddition = '';
        let locale = "de-DE"; //static because de-AT = 1 000,00; de-DE = 1.000,00; standard = 1,000.00
        if (data.format){
            formatAddition = data.format;
        }

        let dataset = [];
        let ctx = findIn(selectors.container, baseElement);

        for (const [key, value] of Object.entries(statistics)){
            dataset.push({
                label: key,
                data: value.values,
                borderWidth: 2,
                backgroundColor: 'rgba('+value.color+')',
                borderColor: 'rgba('+value.color+')',
                pointHoverBackgroundColor: 'rgba(255, 255, 255)',
                fill: {
                    target: 'origin',
                    above: 'rgba('+value.color+', 0.2)',
                }
            });
        }

        new Chart(ctx, {
            type: type,
            data: {
                labels: labels,
                datasets: dataset
            },
            options: {
                locale: locale,
                scales: {
                    y: {
                        beginAtZero: true,
                        suggestedMax: 300,
                        ticks: {
                            callback: function(value, index, ticks) {
                                if (formatAddition){
                                    return formatAddition + ' ' + new Intl.NumberFormat(locale).format(value);
                                }else{
                                    return value;
                                }
                            }
                        }
                    },
                },
                plugins: {
                    tooltip: {
                        enabled: false,
                        external: function(context){
                            // Tooltip Element
                            let tooltipEl = document.getElementById('js-statistics__tooltip');

                            // Create element on first render
                            if (!tooltipEl) {
                                tooltipEl = document.createElement('div');
                                tooltipEl.id = 'js-statistics__tooltip';
                                tooltipEl.innerHTML = '<table></table>';
                                document.body.appendChild(tooltipEl);
                                tooltipEl.classList.add('statistics__tooltip-container');

                            }

                            // Hide if no tooltip
                            const tooltipModel = context.tooltip;
                            if (tooltipModel.opacity === 0) {
                                tooltipEl.style.opacity = 0;
                                return;
                            }

                            // Set caret Position
                            tooltipEl.classList.remove('above', 'below', 'no-transform');
                            if (tooltipModel.yAlign) {
                                tooltipEl.classList.add(tooltipModel.yAlign);
                            } else {
                                tooltipEl.classList.add('no-transform');
                            }

                            function getBody(bodyItem) {
                                return bodyItem.lines;
                            }

                            // Set Text
                            if (tooltipModel.body) {
                                const titleLines = tooltipModel.title || [];
                                const bodyLines = tooltipModel.body.map(getBody);


                                let innerHtml = '<thead>';

                                titleLines.forEach(function (title) {
                                    innerHtml += '<tr><th colspan="3" class="statistics__tooltip-title">' + title + '</th></tr>';
                                });
                                innerHtml += '</thead><tbody><tr>';
                                bodyLines.forEach(function (body, i) {
                                    const colors = tooltipModel.labelColors[i];
                                    let style = 'background:' + colors.backgroundColor;
                                    style += '; border-color:' + colors.borderColor;
                                    style += '; border-width: 2px';

                                    let span;
                                    if(formatAddition){
                                        span = '<span class="statistics__tooltip-content" style="' + style + '">' + formatAddition + ' ' + body[0].split(": ")[1] + '</span>';
                                    }else{
                                        span = '<span class="statistics__tooltip-content" style="' + style + '">' + ' ' + body[0].split(": ")[1] + '</span>';
                                    }

                                    innerHtml += '<td>' + span + '</td>';
                                });
                                innerHtml += '</tr></tbody>';

                                let tableRoot = tooltipEl.querySelector('table');
                                tableRoot.innerHTML = innerHtml;
                            }

                            const position = context.chart.canvas.getBoundingClientRect();

                            // Display, position, and set styles for font
                            tooltipEl.style.opacity = 1;
                            tooltipEl.style.position = 'absolute';
                            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                            tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
                            tooltipEl.style.pointerEvents = 'none';
                        }
                    },
                    legend: {
                        display: false
                    },
                },
                interaction: {
                    intersect: true,
                    mode: 'index',
                    position: 'nearest'
                }
            }
        });
    })
}